import { WarningCircle } from "@phosphor-icons/react";
import { TuncaContactButtons } from "../dashboard/DemoCountdownCard";

export default function DeactivatedNotice({ email }: { email: string }) {
  const whatsappText = email
    ? `Merhaba Tunca Hoca, ben ${email}. Kaizu hesabım deaktif görünüyor, eğitime devam etmek istiyorum.`
    : "Merhaba Tunca Hoca, Kaizu hesabım deaktif görünüyor, eğitime devam etmek istiyorum.";

  return (
    <div className="rounded-2xl border border-red-500/40 bg-red-500/10 p-4 mb-6">
      <div className="flex items-start gap-3">
        <WarningCircle size={24} weight="fill" className="text-red-400" />
        <div className="flex-1">
          <div className="text-base font-bold text-red-400 mb-0.5">
            Hesabın şu an aktif değil
          </div>
          <div className="text-white/60 text-sm">
            Eğitimine devam etmek istiyorsan Tunca Hoca'ya yaz, hesabını tekrar açalım.
          </div>
          <TuncaContactButtons whatsappText={whatsappText} />
        </div>
      </div>
    </div>
  );
}
